import React from "react";
import Alert from "./Alert";
import Info from "./Info";

export default function Index() {
  return (
    <div className="space-y-3 pb-3">
      <Alert />
      <Info />
    </div>
  );
}
